import { render, staticRenderFns } from "./MaterialTypeModal.vue?vue&type=template&id=35b65010&scoped=true"
import script from "./MaterialTypeModal.vue?vue&type=script&lang=js"
export * from "./MaterialTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b65010",
  null
  
)

export default component.exports